module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chap",
    attrs: {
      "epub:type": "chapter",
      "id": "chap-001"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _vm._v(" "), _c('h1', {
    staticClass: "chap_n",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("1")])]), _vm._v(" "), _c('h1', {
    staticClass: "chap_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("The Crises of Leading Change")])]), _vm._v(" "), _c('h1', {
    staticClass: "chap_stit",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_c('span', [_vm._v("Failures of Nerve and"), _c('br'), _vm._v("\n    Failures of Heart")])]), _vm._v(" "), _c('div', {
    staticClass: "exergues"
  }, [_c('div', {
    staticClass: "exer"
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("The battles the Greek heroes had to fight were against their enemies.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("The battles their Jewish counterparts had to fight were against themselves:")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_centre last"
  }, [_c('i', [_vm._v("their fears, their hesitations, their sense of unworthiness.")])]), _vm._v(" "), _c('div', {
    staticClass: "exer_source"
  }, [_c('b', [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONATHAN")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ACKS")])])])]), _vm._v(" "), _c('div', {
    staticClass: "exer"
  }, [_c('p', {
    staticClass: "txt_courant_centre last"
  }, [_c('i', [_vm._v("I believe there exists throughout America today a rampant sabotaging of leaders who try to stand tall amid the raging anxiety-storms of our time . . . whenever a [group] is driven by anxiety, what will also always be present is a failure of nerve among its leaders.")])]), _vm._v(" "), _c('div', {
    staticClass: "exer_source"
  }, [_c('b', [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DWIN")]), _vm._v(" H. F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIEDMAN")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "let"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("OD, GIVE US YOUR PITCH")]), _vm._v(". Treat us as if we are the people who you would ask to fund this if it was a new start-up company.”")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I smiled broadly. “Glad to do so,” I said as I forwarded the PowerPoint presentation to the first slide.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  }, [_vm._v("I was in a conference room provided by a law office, meeting with a group of Silicon Valley venture capitalists on a famous street in Palo Alto, California. We were there to discuss a change initiative I had been tasked to spearhead at the seminary where I am a senior administrator. They were not there to fund the initiative but to give me feedback on it using their expertise as venture capitalists and philanthropists.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("As I took a deep breath to launch into my presentation, a former McKinsey consultant interrupted, “Sorry,” he said. “Before you start just tell us, "), _c('i', [_vm._v("who")]), _vm._v(" this new service is supposed to help? Who is your target "), _c('i', [_vm._v("customer")]), _vm._v(", as it were?” We all chuckled. Seminaries, churches, and Christian nonprofits don’t often refer to the people we serve as “customers.” But I got the point.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“No problem,” I said, “Fuller Seminary wants to serve ministry leaders and pastors who want to grow as spiritual leaders and help the people in their churches and organizations grow spiritually but don’t necessarily need the expense or commitment of graduate-level education.”")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("There were nods all around the room, so I began.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Twelve minutes later I finished my presentation. I could see smiles around the room as if they were sharing an inside joke. The former McKinsey consultant said, “You have been doing that presentation a lot around the seminary, haven’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“Yes,” I responded. “Faculty groups, senior administrators, staff groups from which I am trying to recruit people to my team. Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“Because your presentation didn’t tell us why this would help ministry leaders but why this was a good strategy for "), _c('i', [_vm._v("the school")]), _vm._v(". You gave us a pitch that tried to sell us on how your plan would help the seminary, not how the seminary would better serve the church or make a difference in the world.”")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "title": "15"
    }
  }, [_vm._v("I could feel my face flush with embarrassment. They were kind, but I knew that a glaring blind spot had been revealed. I also realized how thoroughly I had been influenced by my institutional context and the worries of my colleagues.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Only three years earlier I had been brought to the seminary as both a former alum with two degrees and as an outsider who had spent the past twenty-five years as the pastor of a congregation, leadership consultant, and executive coach. I was supposed to be the voice of the church speaking into and shaping the academic environment in a more formative direction. And while, in my presentation, I had used the language of making an impact on the greater church, I had defaulted—almost unconsciously—to what would help "), _c('i', [_vm._v("our institution")]), _vm._v(" and not what would truly help our institution serve the real needs of people.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Back to the conference room in Silicon Valley. The most senior leader in the room spoke up next. “Tod, look, there is only really one thing that matters if you are going to try to lead something innovative: "), _c('i', [_vm._v("Does it fix a real problem?")]), _vm._v("” He continued, “Can you tell us what "), _c('i', [_vm._v("pain point")]), _vm._v(" in the world or the church your seminary’s new project would be trying to address?”")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I still feel sheepish looking back on it now, but these Silicon Valley leaders were reminding me that genuine leadership must be focused on a vision that is beyond the profit, success, or even survival of the institution. "), _c('i', [_vm._v("It must be focused on the needs of real people in the real world.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Very quickly, the conversation with the Silicon Valley venture capitalists moved from what the school wanted me to do to what the world "), _c('i', [_vm._v("needed to have done")]), _vm._v(". And this not only refocused my sense of what was required of me as a leader but also the constant temptation that every leader faces.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "title": "16"
    }
  }, [_vm._v("In "), _c('i', [_vm._v("Canoeing the Mountains")]), _vm._v(", I defined leadership as “energizing a community of people toward their transformation to accomplish a shared mission in the face of a changing world.”"), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-005"
    }
  }), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-004",
      "id": "ap_ntf-004-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" For Christians the motivating factor for leadership is "), _c('i', [_vm._v("mission")]), _vm._v(". Christian leadership is fundamentally about gathering people together to become a "), _c('i', [_vm._v("community to grow in order to accomplish something that needs to be done in the name of Christ")]), _vm._v(". That mission is focused on a need or pain point that if addressed would further the redemptive purposes of God in the world. It is the desire to be a tangible, particular, and contextual answer to the prayer of Jesus, “Your kingdom come, your will be done on "), _c('i', [_vm._v("earth")]), _vm._v(". . . .”")])]), _vm._v(" "), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_c('b', [_c('i', [_vm._v("Leadership is called into action when there is a problem")]), _vm._v(" outside "), _c('i', [_vm._v("of the organization that needs to be addressed")]), _vm._v(" and the organization needs to change "), _c('i', [_vm._v("in order to take on that challenge")]), _vm._v(".")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("For most of us this is straightforward enough. Indeed, those of us called to leadership are motivated by words like "), _c('i', [_vm._v("transformation")]), _vm._v(" and "), _c('i', [_vm._v("mission")]), _vm._v(". We are eager to make a difference, meet a need, and, if we are people of Christian faith, see God’s reign made manifest in our towns, churches, and organizations. Leadership, as my Silicon Valley counselors were reminding me, is called into action when there is a problem "), _c('i', [_vm._v("outside")]), _vm._v(" of the organization that needs to be addressed "), _c('i', [_vm._v("and the organization needs to change")]), _vm._v(" in order to take on that challenge.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("One of the genuine crises of Christian leadership today is how inward focused it is. A movement founded on the salvation and transformation of the world often becomes consumed with helping a congregation, an organization, or educational institution survive, stay together, or deal with rampant anxiety (often all at the same time). It’s not enough to turn around a "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "title": "17"
    }
  }, [_vm._v("declining church, resolve conflict, restore a sense of community, regain a business’s market share, return an organization to sustainability, or even “save the company.” The question before any leader of an organization is “save the company for "), _c('i', [_vm._v("what")]), _vm._v("?”")])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-003"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("The Challenge of Adaptive Leadership")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The man across the table from me was a generous and successful businessman. He had already given a considerable donation to the work my team was spearheading at the seminary, and we were asking him for even more resources.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("He looked at me and asked, “So if another seminary asks you to share what you are learning, what will you do? What will you say to them?”")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“It’s already happened,” I told him. “I have already spoken to a dozen or more schools and seminaries. And when they call, we tell them everything. Everything we have learned. Every mistake we have made. Every pothole to avoid. Everything we haven’t yet tried. We share it all.” We talked about that what he was funding through us was bigger than us. That what we are trying to do in leadership formation is bigger than any one school. Soon we were talking about Elon Musk’s work with Tesla and how he had made the plans for the batteries on his electric vehicles an open-source technology, sharing all of the patents so that other companies could accelerate the vehicles that he believed would help fight climate change."), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-006"
    }
  }), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-005",
      "id": "ap_ntf-005-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_c('b', [_c('i', [_vm._v("Developing")]), _vm._v(" adaptive capacity, that is, the personal and organizational transformation of leaders and their people to apply and adapt their core values in a rapidly changing context, "), _c('i', [_vm._v("is the greatest challenge of adaptive leadership.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“The real challenge,” I said, “is not figuring out the new plans but changing the factories that are used to building on the old plans.” I explained that even if we gave every so-called competitor our plans for innovating Christian leadership formation and theological education, they would have to change their own organizational cultures. That is, both the leaders and their organizations need to adapt.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18",
      "title": "18"
    }
  }, [_vm._v("Adaptive leadership, as developed by Ronald Heifetz and Marty Linsky, is an approach to organizational problem-solving that starts with diagnosis:"), _c('i', [_vm._v(" Is this problem something that an expert can solve or not? ")]), _vm._v("Is this something that requires us to apply a solution that already exists, or does it fall outside of our current knowledge and expertise and therefore will require learning (and usually result in loss)?"), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-007"
    }
  }), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-006",
      "id": "ap_ntf-006-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("Adaptive challenges are the true tests of leadership. They are challenges that go beyond the technical solutions of resident experts or best practices, or even the organization’s current knowledge. They arise when the world around us has changed but we continue to live on the successes of the past. They are challenges that cannot be solved through compromise or win-win scenarios, or by adding another ministry or staff person to the team. They demand that leaders make hard choices about what to preserve and to let go. They are challenges that require people to learn and to "), _c('i', [_vm._v("change")]), _vm._v(", that require leaders to experience and navigate profound "), _c('i', [_vm._v("loss")]), _vm._v("."), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-008"
    }
  }), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-007",
      "id": "ap_ntf-007-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("As we shall repeatedly see, developing "), _c('i', [_vm._v("adaptive capacity")]), _vm._v(", that is"), _c('i', [_vm._v(", the personal and organizational transformation of leaders and their people to apply and adapt their core values in a rapidly changing context")]), _vm._v(", is the greatest challenge of adaptive leadership."), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-009"
    }
  }), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-008",
      "id": "ap_ntf-008-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" Groups are hardwired to believe that survival usually "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19",
      "title": "19"
    }
  }, [_vm._v("means reinforcing the way things have always been. So when an organization feels stress, the default behavior of most organizational leaders is to solve the problems "), _c('i', [_vm._v("for")]), _vm._v(" our organizations rather than "), _c('i', [_vm._v("change our organizations")]), _vm._v(" for meeting the needs of the world. The result is that instead of undergoing transformation to be more effective in our mission to serve the world, organizations unconsciously reinforce the very status quo that is "), _c('i', [_vm._v("not working")]), _vm._v(".")])]), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_c('b', [_c('i', [_vm._v(" The default behavior of most organizational leaders is to solve problems")]), _vm._v(" for "), _c('i', [_vm._v("our organizations rather than")]), _vm._v(" change our organizations "), _c('i', [_vm._v("for meeting the needs of the world")]), _vm._v(". ")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("So, to restore their flagging attendance or lagging donations, churches keep offering the programs they have always loved and try to fill the facilities that they invested in building. Schools want to attract students to maintain the faculty who have come to research within the safety of tenure and the resources of an academic community. Nonprofit organizations that were once an innovative solution to a real problem become, after a time, organizations whose own survival is now the core purpose for being.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("But, when a changing world or changing needs require that the church, school, organization, or institution change to keep being relevant to the real challenge that is arising, it becomes clear that the "), _c('i', [_vm._v("internal")]), _vm._v(" organizational change needed—and the losses that must be faced by our people to become more missionally focused—is an even more difficult leadership challenge than the external reason for changing. And when leaders experience the resistance of "), _c('i', [_vm._v("their people")]), _vm._v(", failure of nerve or failure of heart begins to take root.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20",
      "title": "20"
    }
  }, [_vm._v("In the Scriptures we see the people of God wrestle with the losses and learning required of them from the very earliest days—and we see Moses struggling to keep the people of God focused on securing the very freedom they have been promised. In Exodus 13, when Pharaoh lets the Israelites go, God leads his people in a roundabout way through the wilderness. Even though they had just been rescued from slavery through God’s multifaceted and miraculous intervention, God knows they are not ready for freedom. He knows he can’t take them on the most direct route to the Promised Land because it would risk a confrontation with their centuries-old nemesis, the Philistines, and any confrontation may make them “change their minds and return to Egypt.” ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Exodus+13%3A17&version=NRSV",
      "target": "_blank"
    }
  }, [_vm._v("Exodus 13:17")]), _vm._v(").")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("As they camped on the Egyptian side of the Red Sea, the word goes out that Pharaoh is coming for them. In a panic they cry out to God and accuse Moses,")]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("Was it because there were no graves in Egypt that you have taken us away to die in the wilderness? What have you done to us, bringing us out of Egypt? Is this not the very thing we told you in Egypt, “Let us alone and let us serve the Egyptians”? For it would have been better for us to serve the Egyptians than to die in the wilderness. ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Exodus+14%3A11-12&version=NRSV",
      "target": "_blank"
    }
  }, [_vm._v("Exodus 14:11-12")]), _vm._v(").")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Moses assures them of God’s presence and power that will protect them, and soon they are standing on the opposite shore of the Red Sea, watching the Egyptian warriors being drowned in the very same spot they had walked across on dry land. They see firsthand God’s power again, and Exodus 14 ends with, “So the people feared the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" and believed in the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" and in his servant Moses.”")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("After ten plagues and salvation at the Red Sea, the Israelites are full of faith and courage; eager to press on to the Promised "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_21",
      "title": "21"
    }
  }, [_vm._v("Land. They gather in joyful celebration, and Moses leads them in a song of praise of God’s power and trust in God’s steadfast love. Moses’ sister, Miriam, leads them in another song and they set out from the Red Sea. They experience yet another miracle as God turns bitter, undrinkable water “sweet” (no small feat in a desert) and demonstrates again God’s care for the people as they drink their fill.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We would think that having personally experienced such a display of power and love that they had written new worship songs to declare it, they would be more resilient when the rough times come. But in the very first challenge, their faith and courage fold like a deck chair.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In Exodus 16, only "), _c('i', [_vm._v("six weeks ")]), _vm._v("after the miracle of the Red Sea, we read, “The whole congregation of the Israelites complained against Moses and Aaron” (v. 2). Protestations soon became a wish to return to slavery in Egypt rather than risk hunger in the wilderness.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Six weeks. One chapter of the book of Exodus. That’s how long it took for the experience of loss and anxiety to completely crumble the convictions of the people of God on a journey to salvation. That’s how long it took for the people to turn on their leaders. That’s how long it took for sabotage to take hold.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("For Edwin Friedman, who was both a family systems expert and a rabbi, "), _c('i', [_vm._v("this is the critical moment in every leadership challenge")]), _vm._v(". This the test that must be passed to truly bring transformation and change: "), _c('i', [_vm._v("to have the resilience to resist one’s own failure of nerve and overcome the anxiety-fueled sabotage that comes when leaders take new initiatives")]), _vm._v("."), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-010"
    }
  }), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-009",
      "id": "ap_ntf-009-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" “The system . . . must produce leaders who can both take the first step and maintain the stamina to follow through in the face of predictable resistance and sabotage.”"), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-011"
    }
  }), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-010",
      "id": "ap_ntf-010-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_22",
      "title": "22"
    }
  }, [_vm._v("And, if my conversations with Christian leaders all over the country are indicative, this may be the single greatest leadership weakness in the church today. While many healthy churches are giving faithful witness to Christ across the globe, most leaders have not been trained for the challenge of trying to bring change to churches that need transformation in order to be faithful to their missional calling. And this is true for educational leaders, nonprofit leaders, or any other organization that have stakeholders who were trained for a bygone era. In the now-famous words of Ronald Heifetz and Marty Linsky:")])]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("People do not resist change, per se. People resist loss. You appear dangerous to people when you question their values, beliefs, or habits of a lifetime. You place yourself on the line when you tell people what they need to hear rather than what they want to hear. Although you may see with clarity and passion a promising future of progress and gain, people will see with equal passion the losses you are asking them to sustain."), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-012"
    }
  }), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-011",
      "id": "ap_ntf-011-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("When a leader raises awareness of the need for change, the natural result is for stakeholders to resist that change and the loss of that change. That resistance soon turns to sabotage.")])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-004"
    }
  }, [_c('h2', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Sabotage in the Sanctuary and the Seminary")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("“So, what’s Plan B?”")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We were midpoint in a capital campaign to raise the funds for a building project at our church, and I was confused by the question. Five months after the infamous 9/11 terrorist attacks on the World Trade Center and the Pentagon, our mostly older congregation had voted courageously, stunningly, faithfully, and unanimously to tear down almost our entire campus and rebuild it so we could better serve the hundreds of young families "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_23",
      "title": "23"
    }
  }, [_vm._v("that were being projected to move into our San Clemente community. We had revealed our plans, candidly  talked about the costs, discussed the disruptions that would become part of our church life for several years, and had called for the vote. It had been a landmark moment in the life of our church and a great accomplishment for our leadership team.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“Plan B? Why would we need a Plan B?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("My business administrator, whom I will call Bob, looked at me kindly. “I know that everyone voted for the plan, Tod. But what if they don’t give to it? What will we do if the money runs short?”")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Exasperated a bit, I snapped at Bob, “We told everyone the cost and they "), _c('i', [_vm._v("voted")]), _vm._v(" for it. They knew what they were doing. Why would that be any different now?”")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("“Well,” he said slowly, “You know, Jay?”")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Everyone knew Jay. Jay was considered by most to be the wealthiest man in our congregation. He might have been the wealthiest man in our community. It had been significant when Jay raised his hand to vote in favor of the building plan because most people assumed that if Jay supported it, it would succeed. And secretly, I think all of us (including me) thought that Jay could personally write a check that would cover a huge part of the money needed to be raised.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("He continued. “Jay was deeply offended by your presentation. You know, thirty years ago, he personally built most of the buildings that we are now tearing down.”")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("(I "), _c('i', [_vm._v("didn’t")]), _vm._v(" know. Somehow, no one had thought to tell me that when I was preparing a presentation about our “poorly constructed buildings that cut corners and were now completely out-of-compliance with the city ordinances.”)")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("He only voted for the project because he was embarrassed, and he knew people were looking at him. But when he raised "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_24",
      "title": "24"
    }
  }, [_vm._v("his hand to vote for the project, everyone "), _c('i', [_vm._v("assumed")]), _vm._v(" that it was good with Jay and that he would contribute a lot. But now Jay and his buddies were telling their friends that they were all going to give $1,000 to the campaign (instead of the $1 million he could give) so that they could "), _c('i', [_vm._v("say")]), _vm._v(" that they supported it. And then Jay told someone, “We will all watch that boy from Los Angeles fall on his ass.”")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("That “boy” was me.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Sabotage.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("First, sabotage is normal. Second, sabotage is what usually leads both to a leader’s failure of "), _c('i', [_vm._v("nerve")]), _vm._v(" and failure of "), _c('i', [_vm._v("heart")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Sabotage is normal.")]), _vm._v(" Acts of sabotage are not the bad things that evil people do to stop good being done in the world. Acts of sabotage are the human things that anxious people do because they fear they are losing what little good is left in the world. Sabotage happens every time a leader takes the initiative to start a change process. It’s so intrinsically linked to leading change that, as Edwin Friedman has written,")]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("The important thing to remember about the phenomenon of sabotage is that it is a systemic part of leadership—part and parcel of the leadership process. Another way of putting this is that a leader can never assume success because he or she has brought about a change. It is only after having first brought about a change and then subsequently endured the resultant sabotage that the leader can feel truly successful."), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-013"
    }
  }), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-012",
      "id": "ap_ntf-012-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This is true for every leader and in every leadership context. “If you are a leader, expect sabotage,” Friedman used to tell his audiences."), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-014"
    }
  }), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-013",
      "id": "ap_ntf-013-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" And indeed, in every change initiative that I have led, I have experience sabotage firsthand. Yes, there was Jay and a congregation that “forgot” to tell me that I was insulting "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_25",
      "title": "25"
    }
  }, [_vm._v("the most important person for a successful building project. And I experienced a two-year effort for bringing change to my denomination go down in flames without a single leader who pledged their support speaking up to help secure its passage."), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-015"
    }
  }), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-014",
      "id": "ap_ntf-014-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" But even today, leading in the face of sabotage is an ongoing challenge in an educational institution that I "), _c('i', [_vm._v("love")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_c('b', [_c('i', [_vm._v("Acts of sabotage are not the bad things that evil people do. Acts of sabotage are the human things that anxious people do.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("When I was the first appointment of a new and highly respected president at Fuller, the first phone calls I received when I took up residence in my new office were from previous leaders at Fuller who wished me well. When I would describe the initiative that we were undertaking to bring a radical and overdue change to theological education, they would each warn me that they too had once been in my role. They too had been in charge of a new presidential initiative that flourished for a time and then eventually the system had reverted to the status quo. I was taken to lunch by experienced administrators who shared with me stories of other institutions that had been innovative—for a time—before eventually the old guard would raise up and take down the new thing. As Scott Anthony, Clark Gilbert, and Mark Johnson wrote, “the great sucking sounds of yesterday can subtly but importantly pull an organization back to what it was trying to get away from.”"), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-016"
    }
  }), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-015",
      "id": "ap_ntf-015-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("One former executive of Boeing, who has interviewed more leaders of more industries than anyone I have ever met, warned me that most initiatives go the way of the famous Saturn project for General Motors. Saturn was launched in 1985 as a “revolutionary” new car company. An independent subsidiary of "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_26",
      "title": "26"
    }
  }, [_vm._v("General Motors, Saturn was specifically conceived to be an innovative response to the rapid growth and competition of Japanese car manufacturers. Offering a different kind of car than the GM’s flagship brands (Chevrolet, Buick, Pontiac, etc.), by 1994 it was the third bestselling brand in America. By 2010, it was closed. As David Hanna wrote in "), _c('i', [_vm._v("Forbes")]), _vm._v(" magazine at the time, “Saturn, a GM company that had great promise in the early 1990s, ultimately failed because senior GM leaders couldn’t see the benefits of new ways of doing things and a new kind of organizational culture.”"), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-017"
    }
  }), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-016",
      "id": "ap_ntf-016-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" Even today, in a time of great disruption and change at Fuller, an institution known for innovation, the threat of reverting to the past is a constant temptation.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("What starts as an innovation to create a new market, ends up getting sacrificed for the status quo and to maintaining the very organizational culture that is contributing to decline in the first place. If it can be said that the most often repeated words of resistance to change is “We have never done it this way before,” then the corollary must be “And we are going to keep doing it the way that is "), _c('i', [_vm._v("not")]), _vm._v(" working, so help us God.”")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Churches, seminaries, and nonprofit organizations are notorious for saying they need change and then resisting the very leader they called to bring it. One of my consulting clients told me that he called a meeting of the Session (the governing board in a Presbyterian church) and brought them a daunting dose of reality by showing them that at the rate they were losing members and hemorrhaging money they could predict when they would have to close their doors. The pastor reminded them that they had called him to “turn the church around” and bring in new families in what is a community where the demographic trends are in their favor. Convinced that the urgency of the moment would lead to their support of his change initiatives, he asked them for more clear and vocal support.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_27",
      "title": "27"
    }
  }, [_vm._v("They all timidly assured him that they would. But later, one older member called him aside “‘Pastor, we all know that you need to bring some changes or the church is going to die. It’s just that this is "), _c('i', [_vm._v("our")]), _vm._v(" church, and while we know it needs to change, we like it the way it is. Could we just figure out how to delay those changes until after "), _c('i', [_vm._v("some of us die")]), _vm._v(" first?”")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The pastor told me, “I had to explain to them that because they took better care of their physical health than the spiritual health of the church that it was likely that the church would die before they did.”")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("At times of crisis or crossroads of change, anxious relationship systems default back to what is known, believing that it is the only path to self-preservation and survival, even if it means returning to slavery ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Exodus+16%3A3&version=NRSV",
      "target": "_blank"
    }
  }, [_vm._v("Exodus 16:3")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("For most leaders this is the most daunting and discouraging dose of reality. That was true for Moses too. The former chief rabbi of London, Jonathan Sacks, points out that while Moses faced a hungry and grumbling Israel with faith, conviction, and creativity in Exodus 16, in Numbers 11:4-15, when they complained about the food "), _c('i', [_vm._v("yet again")]), _vm._v(", he was ready to throw in the towel. The challenge is the same, the response of the people of God is the same, the resistance to change is ongoing, and now, even later in the journey, Moses is demoralized that Israel continues to threaten to turn back. He loses patience and grows frustrated with God, brittle in his character, descending into his own pity party, even asking God to “put me to death at once.”")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Sacks comments on this passage, tying it back to his study of adaptive leadership concepts.")]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre"
  }, [_vm._v("In the first occasion, Moses was faced with a technical challenge: the people needed food. On the second occasion he was faced "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_28",
      "title": "28"
    }
  }, [_vm._v("with an adaptive challenge. The problem was no longer the food but the people. They had begun the second half of their journey, from Sinai to the Promised Land. They had escaped from slavery; they now needed to develop the strength and self-confidence necessary to fight battles and create a free society. They were the problem. They had to change. That [is what makes] adaptive  leadership so difficult. People resist change, and can become angry and hostile when faced with the need for it."), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-018"
    }
  }), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-017",
      "id": "ap_ntf-017-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Every group I have spoken to in the past five years requested that—whatever else I teach on leading change—I had to include "), _c('i', [_vm._v("sabotage")]), _vm._v(": how to lead through it—and even more—how to develop the resilience to persist in the face of it. Which leads to the second point for beginning this discussion.")]), _vm._v(" "), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant_droite"
  }, [_c('b', [_c('i', [_vm._v("Failure of nerve is caving to the pressure of the anxiety of the group to return to the status quo. Failure of heart is when the leader’s discouragement leads them to psychologically abandon their people and the charge they have been given.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Sabotage is often the cause for either a change leader’s failure of nerve or failure of heart. ")]), _vm._v("As I traveled the country talking to different groups, I began to notice that the most important conversation was not in the question-and-answer session in my workshops, but was during the meal with the leader who had invited me to speak to their group. I began to notice the number of leaders who confessed to me that they felt like Moses in Numbers 11 and were beginning to shrink back facing a “mountain of despair.” They began to realize that the tendency for organizations to sabotage change efforts by defaulting back to security and self-preservation was "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_29",
      "title": "29"
    }
  }, [_vm._v("contributing to more leaders suffering both failure of nerve and failure of heart.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Failure of nerve is caving to the pressure of the anxiety of the group to return to the status quo. It is a loss of courage to further the mission and a return to Egypt. Failure of heart is the “emotional cutoff” that occurs when the leader’s discouragement leads them to psychologically abandon their people and the charge they have been given."), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-019"
    }
  }), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-018",
      "id": "ap_ntf-018-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" If failure of nerve is being too soft and accommodating to lead change, then failure of heart is becoming so hardened and brittle that leading the change process is changing the leader for the worse. It is becoming so angry at God or cynical about the very people that we have been given to lead that soon we are demanding that God relieve us of the burden, or, in Moses’ case, “to put me to death.”")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In a failure of heart, the first thing to go is hope and energy; soon the very empathy and attunement necessary to help a group adjust to loss and resist despair turn to cynicism, and that in turn results in the entire leading-change effort to be quietly abandoned and the leader often with it. As Edwin Friedman writes, “The capacity of a leader to be prepared for, to be aware of, and to learn how to skillfully deal with this type of crisis (sabotage) may be the most important aspect of leadership. It is literally the key to the kingdom.”"), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-020"
    }
  }), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-019",
      "id": "ap_ntf-019-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('div', {
    staticClass: "encombre",
    attrs: {
      "id": "enc-003"
    }
  }, [_c('h2', {
    staticClass: "enc_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("CONSIDER")])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_centre retrait_autre"
  }, [_vm._v("When in your leadership have you suffered from either a failure of nerve or a failure of heart? To which are you more susceptible and why? ")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Resilience in the face of sabotage is the antidote to the leaders’ failure of nerve "), _c('i', [_vm._v("and")]), _vm._v(" failure of heart. A tempered, resilient leader "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_30",
      "title": "30"
    }
  }, [_vm._v("doesn’t comply with the group anxiety to return to the status quo. And a tempered leader does not become brittle and angry or discouraged and disconnected. Resilience is not something that can be mustered in a moment of “rising to the occasion.”"), _c('a', {
    staticClass: "renvlnk",
    attrs: {
      "id": "renvlnk-021"
    }
  }), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen5#ntf-020",
      "id": "ap_ntf-020-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" It is formed over a long period "), _c('i', [_vm._v("before")]), _vm._v(" the crisis of testing so that it can continue the transformation "), _c('i', [_vm._v("during")]), _vm._v(" the moment of challenge. Like a soft piece of metal that must be transformed into a chisel to hew a hard granite slab, it has to be worked. The steel has to be transformed—forged and formed and "), _c('i', [_vm._v("tempered")]), _vm._v("—so that it becomes strong and flexible enough to, as Dr. King said, hew stones of hope out of a mountain of despair.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In congregations and organizations filled with resistance to the very changes that need to be made to live out even their most cherished values, leaders need exceedingly elusive character qualities. So, as we consider what it takes to forge resilience in the face of resistance, we begin with the most precious—and rare—raw material.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d79414a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap1.vue
// module id = 69
// module chunks = 0